import { useTranslation } from 'react-i18next';
import './ConnectionBanner.scss';

export type ConnectionBannerStatus = 'offline' | 'reconnecting' | 'restored';

const TEXT_KEYS: Record<ConnectionBannerStatus, string> = {
	offline: 'chatNoInternet',
	reconnecting: 'chatReconnecting',
	restored: 'chatConnectionRestored',
};

/** Messenger-style strip at the top of the chat telling the user about their connection. */
function ConnectionBanner({ status }: { status: ConnectionBannerStatus }) {
	const { t } = useTranslation();
	return (
		<div className={`chat-connection-banner is-${status}`} id='chat_connection-banner' role='status' aria-live='polite'>
			{t<string>(TEXT_KEYS[status])}
		</div>
	);
}

export default ConnectionBanner;
